import { render, staticRenderFns } from "./ConnectMailbox.vue?vue&type=template&id=68c154e2&scoped=true&"
import script from "./ConnectMailbox.vue?vue&type=script&lang=js&"
export * from "./ConnectMailbox.vue?vue&type=script&lang=js&"
import style0 from "./ConnectMailbox.vue?vue&type=style&index=0&id=68c154e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c154e2",
  null
  
)

export default component.exports